module.exports = __webpack_public_path__ + "media/check-green-mp4.mp4";